import { FormGroup } from "@angular/forms";
import { EnginePowerCheck } from "../../../models/engine-power-check.model";
import { text } from "../../form/controls";

/** A reading of the engine power check: the flight's field and the column of each engine. */
export const EPC_READINGS = [
    { field: "n1Ng", label: "N1/NG", engine1: "engine1N1NG", engine2: "engine2N1NG" },
    { field: "nr", label: "NR", engine1: "engine1NR", engine2: "engine2NR" },
    { field: "totItt", label: "TOT/ITT", engine1: "engine1TOTITT", engine2: "engine2TOTITT" },
    { field: "tq", label: "TQ", engine1: "engine1TQ", engine2: "engine2TQ" },
    { field: "deltaN1", label: "ΔN1", engine1: "engine1DeltaN1", engine2: "engine2deltaN1" },
    { field: "deltaT4", label: "ΔT4", engine1: "engine1deltaT4", engine2: "engine2deltaT4" },
    { field: "deltaTot", label: "ΔTOT", engine1: "engine1DeltaTOT", engine2: "engine2DeltaTOT" },
    { field: "deltaTq", label: "ΔTQ", engine1: "engine1deltaTQ", engine2: "engine2deltaTQ" },
] as const;

/** One form, whether or not the flight has the check: an empty one logs it. */
export function buildEnginePowerCheckGroup(check: EnginePowerCheck | null) {
    const readings = (engine: 1 | 2) => {
        const values = engine === 1 ? check?.engine1 : check?.engine2;
        return Object.fromEntries(EPC_READINGS.map((reading) => [reading[`engine${engine}`], text(values?.[reading.field] ?? null)]));
    };
    return new FormGroup({ oat: text(check?.oat ?? null), altitude: text(check?.altitude ?? null), ...readings(1), ...readings(2) });
}

export type EnginePowerCheckGroup = ReturnType<typeof buildEnginePowerCheckGroup>;
